<template>
	<div>
		<!-- After transaction is created, show update -->
		<aeg-update-transaction
			v-if="transactionId"
			:claimId="claimId"
			:transactionId="transactionId"
			@done="$emit('done')"
			@transaction:deleted="$emit('transaction:deleted')"
		/>
		<!-- Loading -->
		<div class="xs-12 flex xs-center p4" v-if="isLoading">
			<j-spinner />
		</div>

		<!-- Error -->
		<div class="xs-12 p4 ta2" v-if="!isLoading && !transactionId">
			{{ $t("errors.general") }}
		</div>
	</div>
</template>

<script>
import AegUpdateTransaction from "./AegUpdateTransaction.vue"
import JSpinner from "@/components/JSpinner"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: { AegUpdateTransaction, JSpinner },

	props: {
		claimId: String
	},

	data() {
		return {
			isLoading: false,
			transactionId: ""
		}
	},

	methods: {
		async createTransaction() {
			const query = gql`
				mutation createTransaction($input: createTransactionInput!) {
					createTransaction(input: $input) {
						status
						errors
						createdStatus {
							id
						}
					}
				}
			`
			console.log("Transaction created")

			this.isLoading = true
			const res = await api({
				query,
				variables: { input: { claimId: this.claimId, amount: 0 } }
			})
			this.isLoading = false

			// Check errors
			if (res?.data?.createTransaction?.status !== "success") {
				this.$store.dispatch(
					"showError",
					res?.data?.createTransaction?.errors?.[0] || this.$t("errors.general")
				)
				return
			}

			this.transactionId = res?.data?.createTransaction?.createdStatus?.id || ""
		}
	},

	created() {
		this.createTransaction()
	}
}
</script>